/**
 * @file const/index.js 全局性常量管理
 */

// 鉴宝结果
export const GEM_APPRAISAL_RESULT = [
    {
        text: '鉴定为真',
        icon: 'https://gemapp.cdn.bcebos.com/pic/x0ffmai3207b2888804989a3'
    },
    {
        text: '鉴定为假',
        icon: 'https://gemapp.cdn.bcebos.com/pic/ycczendg2154a12aa816a341'
    },
    {
        text: '无法鉴定',
        icon: 'https://gemapp.cdn.bcebos.com/pic/k057qwpn6d11d9fc4a7ccba3'
    },
    {
        text: '等待专家鉴定中…',
        icon: ''
    }
];

// 页面来源标识（fr字段）
export const PAGE_FROM_SWAN = 'gemsmart';